import { IconButton, Tooltip } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface ToggleButtonProps {
  tooltipTitle: string;
  IconComponent: SvgIconComponent;
  onClick: () => void;
  show: boolean;
}

export const ToggleButton = ({ tooltipTitle, IconComponent, onClick, show }: ToggleButtonProps) => {
  if (!show) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        size="small"
        onClick={onClick}
        sx={{
          flexShrink: 0,
          ml: 0.5,
        }}
      >
        <IconComponent fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
